import type { AppAction } from '..'

export enum ActionType {
  SubscribeToFeatureFlags = 'FEATURE_FLAGS/SUBSCRIBE',
  UnsubscribeToFeatureFlags = 'FEATURE_FLAGS/UNSUBSCRIBE',
  UpdateAllFeatureFlags = 'FEATURE_FLAGS/UPDATE_ALL_FEATURE_FLAGS',
  UpdateFeatureFlag = 'FEATURE_FLAGS/UPDATE_FEATURE_FLAG',
}

export type Action =
  | { type: ActionType.SubscribeToFeatureFlags }
  | {
      type: ActionType.UpdateAllFeatureFlags
      featureFlags: Map<string, boolean>
    }
  | {
      type: ActionType.UpdateFeatureFlag
      featureFlagId: string
      enabled: boolean
    }

export const actions = {
  subscribeToFeatureFlags(): Action {
    return { type: ActionType.SubscribeToFeatureFlags }
  },
  updateAllFeatureFlags(featureFlags: Map<string, boolean>): Action {
    return { type: ActionType.UpdateAllFeatureFlags, featureFlags }
  },
  updateFeatureFlag(featureFlagId: string, enabled: boolean): Action {
    return { type: ActionType.UpdateFeatureFlag, featureFlagId, enabled }
  },
}

export type State = Map<string, boolean>

export const initialState: State = new Map()

export function reducer(state: State = initialState, action: AppAction): State {
  switch (action.type) {
    case ActionType.SubscribeToFeatureFlags:
      return state

    case ActionType.UpdateAllFeatureFlags:
      return action.featureFlags

    default:
      return state
  }
}

// Queries
//
export const queries = {
  isFeatureFlagEnabled(state: State, feature: string): boolean {
    return state[feature] !== undefined && state[feature] === true
  },
}
